module.exports = __webpack_public_path__ + "img/chinesecompany46.ac725a81.png";